<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div class="container" fxLayout="column" fxFill>
  <div class="content_container" fxLayout="row">
    <as-split direction="horizontal">
      <as-split-area [size]="40" [minSize]="30">
        <div class="new_list_container mat-elevation-z0" fxLayout="column">
          <!-- header -->
          <div class="new_header_container" fxLayout="row" fxLayoutAlign="start center">
            <span
              id="workflowTitle"
              class="subtitle"
              i18n="Scheduled task list header@@scheduledTasks"
              >Scheduled tasks</span
            >
            <div class="expand"></div>
          </div>

          <mat-divider></mat-divider>
          <div
            fxLayout="row"
            *ngIf="scheduledTasks$ | async as scheduledTasks"
            class="new_list_item_container"
          >
            <cdk-virtual-scroll-viewport fxFill itemSize="51" *ngIf="scheduledTasks.length > 0">
              <div
                class="new_list_item"
                *cdkVirtualFor="let scheduledTask of scheduledTasks"
                [routerLink]="scheduledTask.taskId"
                routerLinkActive="active_item"
              >
                <div fxLayout="row" fxLayoutAlign="start center">
                  <span
                    *ngIf="scheduledTask.recurring; then recurringTaskIcon; else scheduledTaskIcon"
                  ></span>
                  <ng-template #scheduledTaskIcon>
                    <fa-icon class="list-item-icon icon" [icon]="faCalendar"></fa-icon>
                  </ng-template>

                  <ng-template #recurringTaskIcon>
                    <fa-icon class="list-item-icon icon" [icon]="faRepeat"></fa-icon>
                  </ng-template>

                  <div fxLayout="column" fxLayoutAlign="start">
                    <span>{{ scheduledTask.taskName }}</span>
                    <span
                      *ngIf="
                        scheduledTask.recurring;
                        then recurringTaskConfig;
                        else scheduledTaskConfig
                      "
                    ></span>
                    <ng-template #scheduledTaskConfig>
                      <div class="task-config" fxLayout="row" fxLayoutAlign="start center">
                        <span i18n="Scheduled for@@scheduledFor">Scheduled for</span>&nbsp;
                        <span>
                          {{
                            customDateFormatService.formatDate(
                              scheduledTask.scheduledAt,
                              DateFormat.shortDate
                            )
                          }}
                        </span>
                      </div>
                    </ng-template>
                    <ng-template #recurringTaskConfig>
                      <div class="task-config" fxLayout="row" fxLayoutAlign="start center">
                        <span>
                          {{
                            getRecurringConfigFromService(
                              scheduledTask.recurring!,
                              scheduledTask.scheduledAt
                            )
                          }}</span
                        >
                      </div>
                    </ng-template>
                  </div>
                  <span class="expand"></span>

                  <div
                    *ngIf="
                      scheduledTask.assignedToEmployeeOrEmployeegroup == TaskAssignmentType.EMPLOYEE
                    "
                  >
                    <div
                      *ngIf="
                        employeeExists(scheduledTask.assignedTo[0]);
                        then validUser;
                        else invalidUser
                      "
                    ></div>
                    <ng-template #validUser>
                      <div class="task_assignment_icon">
                        <fa-icon id="employeeIcon" [icon]="faUser"></fa-icon>
                      </div>
                    </ng-template>
                    <ng-template #invalidUser>
                      <div class="task_assignment_icon error_icon">
                        <fa-icon id="missingEmployeeIcon" [icon]="faUserSlash"></fa-icon>
                      </div>
                    </ng-template>
                  </div>
                  <div
                    *ngIf="
                      scheduledTask.assignedToEmployeeOrEmployeegroup ==
                      TaskAssignmentType.EMPLOYEEGROUP
                    "
                  >
                    <div
                      *ngIf="
                        employeeGroupsExist(scheduledTask.assignedTo) as existCount;
                        else invalidUsergroup
                      "
                    >
                      <div
                        class="task_assignment_icon"
                        [ngClass]="{ warn_icon: existCount < scheduledTask.assignedTo.length }"
                      >
                        <fa-icon id="groupIcon" [icon]="faUsers"></fa-icon>
                      </div>
                    </div>
                    <ng-template #invalidUsergroup>
                      <div class="task_assignment_icon error_icon">
                        <fa-icon id="missingGroupIcon" [icon]="faUsersSlash"></fa-icon>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </cdk-virtual-scroll-viewport>
            <div
              *ngIf="scheduledTasks.length === 0"
              fxFill
              fxLayoutAlign="center"
              class="tasks_empty_list"
            >
              <span i18n="Scheduled task list his empty header@@scheduledTasksEmptyList"
                >No scheduled tasks to display. Click
                <a [routerLink]="taskManagerRouterLink">here</a> to schedule a new task.</span
              >
            </div>
          </div>
        </div>
      </as-split-area>
      <as-split-area [size]="60" [minSize]="30">
        <div class="detail">
          <router-outlet></router-outlet>
        </div>
      </as-split-area>
    </as-split>
  </div>
</div>
